import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SchemaOrgProps {
  type: 'Organization' | 'LocalBusiness' | 'WebSite' | 'FAQPage';
  name?: string;
  description?: string;
  url?: string;
  logo?: string;
  sameAs?: string[];
  address?: {
    streetAddress: string;
    addressLocality: string;
    postalCode: string;
    addressCountry: string;
  };
  faqItems?: Array<{
    question: string;
    answer: string;
  }>;
}

const SchemaOrg: React.FC<SchemaOrgProps> = ({ 
  type, 
  name = 'S+D Solutions',
  description,
  url = 'https://www.splusd-solutions.com',
  logo = 'https://www.splusd-solutions.com/logo.png',
  sameAs,
  address,
  faqItems,
}) => {
  const renderOrganizationSchema = () => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': type,
      name,
      url,
      logo,
      description,
      ...(sameAs && { sameAs }),
      ...(address && { 
        address: {
          '@type': 'PostalAddress',
          ...address
        } 
      }),
    };
    
    return JSON.stringify(schema);
  };

  const renderFAQSchema = () => {
    if (!faqItems || faqItems.length === 0) return null;
    
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(item => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    };
    
    return JSON.stringify(schema);
  };

  return (
    <Helmet>
      {type === 'FAQPage' ? (
        <script type="application/ld+json">{renderFAQSchema()}</script>
      ) : (
        <script type="application/ld+json">{renderOrganizationSchema()}</script>
      )}
    </Helmet>
  );
};

export default SchemaOrg; 